import { paymentAmount } from "../lib/payment-presentation";

/** Keeps the rial unit physically left of its whole-unit amount in RTL report cells. */
export default function PaymentAmount({ amount, currency }) {
  if (currency !== "IRR") return <bdi>{paymentAmount(amount, currency)}</bdi>;
  const parts = new Intl.NumberFormat("fa-IR", { style: "currency", currency }).formatToParts(amount);
  const unit = parts.find((part) => part.type === "currency")?.value ?? currency;
  const number = parts.filter((part) => !["currency", "literal"].includes(part.type)).map((part) => part.value).join("");
  return <span dir="ltr" className="dk-payment-amount"><bdi>{unit}</bdi><bdi>{number}</bdi></span>;
}
